import type { GeneratedRoofSystem } from "building-types/roofs/generatedRoofSystemTypes";
import type { Table } from "common/data/table";

export function roofSystemsOnLevel(levelId: string, roofSystems: Table<GeneratedRoofSystem>): GeneratedRoofSystem[] {
  const a: GeneratedRoofSystem[] = [];
  for (const roofId in roofSystems) {
    const roofSystem = roofSystems[roofId];

    const { roofs: subRoofs } = roofSystem;
    for (const subRoofId in subRoofs) {
      if (subRoofs[subRoofId].levelId === levelId) {
        a.push(roofSystem);
        break;
      }
    }
  }
  return a;
}
